import React from 'react';
import {LayerTree} from '@terrestris/react-geo';
import './LayerSidebar.css';

export const LayerSidebar = (props) => {
    return (
        <div className={`sidebar ${props.visible ? "open" : ""}`} >
            <div className="content">
                <button className="closebtn" onClick={props.onClose}>✕</button>
                <h2>{props.title}</h2>
              <div style={{backgroundColor:'rgba(0,0,0,0.4)'}}>
              <LayerTree map={props.map} layerGroup={props.tiles}  
             />
              </div>
                {/*
                <h3>Linije</h3>
                <LayerTree map={props.map} layerGroup={props.lines} />*/}
            </div>
        </div>
    )
}